import selectComponentAccounts from './selectComponentAccounts';
import { groupRiskStatus } from '../../../util/uiconstants';

export default () => {
    const componentAccounts = selectComponentAccounts();
    const unmappedComponentAccounts = componentAccounts?.filter(
        ({ groupRiskStatusId }) =>
            groupRiskStatusId === groupRiskStatus.unmapped || groupRiskStatusId === groupRiskStatus.notApplicable
    ) ?? [];
    return unmappedComponentAccounts;
};
